import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTransform',
  standalone: false,
})
export class dateTransform implements PipeTransform {
  transform(modifiedon: string) {
    const one_day = 1000 * 60 * 60 * 24;
    const one_hour = 1000 * 60 * 60;
    const one_minute = 1000 * 60;

    const presentTime = new Date();

    const applicantTime = new Date(modifiedon);

    const differenceInTime1 = presentTime.getTime() - applicantTime.getTime();

    if (Math.round(differenceInTime1) < 0) {
      return 0;
    } // if differenceInTime1 is <0 or negative values it is future
    else {
      if (Math.round(differenceInTime1) > one_day) {
        return Math.round(differenceInTime1 / one_day) + 'd';
      } else if (Math.round(differenceInTime1) < one_day && Math.round(differenceInTime1) > one_hour) {
        return Math.round(differenceInTime1 / one_hour) + 'h';
      } else {
        return Math.round(differenceInTime1 / one_minute) + 'm';
      }
    }
  }
}
